import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class SaasEntitiesApiRequestFactory extends BaseAPIRequestFactory {
    async listSaasEntities(projectId, id, pageToken, pageSize, listSaasEntitiesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SaasEntitiesApi", "listSaasEntities", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SaasEntitiesApi", "listSaasEntities", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSaasEntitiesRequest, "ListSaasEntitiesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSaasEntitySnapshots(projectId, id, saasEntityId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SaasEntitiesApi", "listSaasEntitySnapshots", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SaasEntitiesApi", "listSaasEntitySnapshots", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SaasEntitiesApi", "listSaasEntitySnapshots", "saasEntityId");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class SaasEntitiesApiResponseProcessor {
    async listSaasEntitiesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListSaasEntitiesResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSaasEntitySnapshotsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListSaasEntitySnapshotsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Resource or entity not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
